import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import {
  getDate,
  getDateTime,
  getDisplayAddressCRM,
  getGenderCRM,
  hideMiddleDigits,
} from "app/common/LocalFunction";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";
import { observer } from "mobx-react";
import React, { memo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SaveIcon from "@material-ui/icons/Save";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import { toast } from "react-toastify";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
const LeadSearchPopup = ({
  open,
  handleClose,
  leadPatient,
  searchLead,
  handleChangeFormSearch,
  handleSelect,
}) => {
  console.log("searchLead", searchLead);
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const [selectedRow, setSelectedRow] = useState([]);
  const handleCloseWithValidation = () => {
    if (!selectedRow?.[0]) {
      toast.warning(
        "Không được đóng khi chưa chọn khách hàng trong danh sách!"
      );
      return;
    }
    handleClose();
  };
  return (
    <PopupForm
      open={open}
      size="md"
      handleClose={handleClose}
      title={`Danh sách lead trùng với số điện thoại ${
        searchLead?.phoneNumber ? searchLead?.phoneNumber : ""
      }`}
      formik={{}}
      hiddenClose={searchLead?.hiddenClose}
      action={
        <div className="flex-center gap-1">
          <CommonButton
            className="btn-add"
            onClick={() => {
              if (!selectedRow?.[0]) {
                toast.warning("Vui lòng chọn một khách hàng trong danh sách!");
                return;
              }
              handleSelect(selectedRow?.[0]);
            }}
          >
            {!isMobile && <SaveIcon className="mr-2" />}
            Chọn lead
          </CommonButton>
          {/* <CommonButton className="btn-gray" 
            onClick={() => {
              if (!selectedRow?.[0]) {
                  toast.warning("Không được bỏ qua khi chưa chọn khách hàng trong danh sách!");
                  return;
                }
              handleClose()
            }}
          >
            {!isMobile && <Block className="mr-2" />}
            Đóng
          </CommonButton> */}
        </div>
      }
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <h5>
            Trường hợp lead đã có trên hệ thống:{" "}
            <strong style={{ color: "red" }}>
              Chọn vào họ tên lead và thực hiện tạo hồ sơ cho khách hàng từ lead
              đó
            </strong>
          </h5>
        </Grid>

        <Grid item xs={12}>
          <TableComponent
            data={leadPatient?.content || []}
            titleNodata={t("noData")}
            showOrdinalNumbers
            selectType={"single"}
            initStateRow={selectedRow}
            handleChangeSelectedRows={(row) => setSelectedRow(row)}
            columns={[
              {
                field: "fullName",
                title: t("Thông tin lead"),
                render: (data) => (
                  <>
                    <div>
                      <strong
                        onClick={() => {
                          handleSelect(data);
                        }}
                      >
                        <b>
                          {data?.fullName} - <CopyableCodeCell value={data?.code} size="small" />
                        </b>
                      </strong>
                      <p className="flex">
                        <b style={{ color: "#4276a4" }}>
                          {getDate(data?.birthDate)}{" "}
                        </b>
                        <p>
                          {data?.gender && <> | {getGenderCRM(data?.gender)}</>}
                        </p>
                      </p>
                    </div>
                    {/* <strong
                      onClick={() => {
                        handleSelect(data);
                      }}
                    >
                      {data?.fullName}
                    </strong> */}
                  </>
                ),
              },

              // {
              //   field: "address",
              //   title: "Địa chỉ",
              //   render: (data) => getDisplayAddressCRM(data),
              // },
              {
                field: "phoneNumber",
                title: "Số điện thoại",
                render: (data) => {
                  return (
                    <>
                      <div>
                        {data?.phoneNumber && <>SĐT 1: {hideMiddleDigits(data?.phoneNumber)} </>}
                      </div>
                      <div>
                        {data?.phoneNumber2 && (
                          <>SĐT 2: {hideMiddleDigits(data?.phoneNumber2)} </>
                        )}
                      </div>
                      <div>
                        {data?.phoneNumber3 && (
                          <>SĐT 3: {hideMiddleDigits(data?.phoneNumber3)} </>
                        )}
                      </div>
                      <div>
                        {data?.phoneNumber4 && (
                          <>SĐT 4: {hideMiddleDigits(data?.phoneNumber4)} </>
                        )}
                      </div>
                    </>
                  );
                },
              },

              {
                field: "leadSource.name",
                title: "Nguồn",
                render: (data) => {
                  return (
                    <>
                      {data?.leadSource?.name || ""}
                      {data?.leadSourceDetail &&
                        `(${data?.leadSourceDetail?.name})`}
                    </>
                  );
                },
              },
              {
                field: "agent.name",
                title: "Telesale hiện tại",
                render: (data) => data?.agent?.name || "",
              },
              {
                field: "client.code",
                title: "TT Khách hàng",
                render: (data) => {
                  return (
                    <>
                      <div>
                        {data?.client?.code && (
                          <>
                            Mã: <CopyableCodeCell value={data?.client?.code} size="small" />{" "}
                          </>
                        )}
                      </div>
                      <div>
                        {data?.client?.fullName && (
                          <>
                            Tên: <b>{data?.client?.fullName}</b>{" "}
                          </>
                        )}
                      </div>
                    </>
                  );
                },
              },
              {
                field: "referralPartner.name",
                title: "CTV",
              },
              {
                field: "leadDate",
                title: "Ngày tạo lead",
                render: (rowData) => (getDateTime(rowData?.leadDate)),
              },
              {
                field: "assignmentTime",
                title: "Ngày phân bổ",
                render: (rowData) => (getDateTime(rowData?.assignmentTime)),
              },
              {
                field: "isBadLead",
                title: "Số trừ",
                render: (data) => (
                  <div style={{ textAlign: "center" }}>
                    {data?.isBadLead ? (
                      <RemoveCircleIcon style={{ color: "red" }} />
                    ) : null}
                  </div>
                ),
              },
            ]}
            dataPagination={{
              pageIndex: searchLead?.pageIndex,
              pageSize: searchLead?.pageSize,
              totalElements: leadPatient?.totalElements,
              totalPages: leadPatient?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
};

export default memo(observer(LeadSearchPopup));
